import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { IconButton } from '../Common/IconButton'
import { Pressable } from '../Common/Pressable'
import type { ChecklistWorkflowStatus } from '../../types/schema'
import type { BlockerEntry } from '../../services/checklistStatusMachine'
import type { BlockerCtaSection } from '../../types/checklistBlockerCodes'
import { getWorkflowStatusLabel } from '../../utils/checklistNodeMeta'

export interface StatusBlockerBannerProps {
  pendingStatus: ChecklistWorkflowStatus | null
  blockers: BlockerEntry[]
  onDismiss: () => void
  onBlockerClick: (section: BlockerCtaSection) => void
}

export const StatusBlockerBanner = ({
  pendingStatus,
  blockers,
  onDismiss,
  onBlockerClick,
}: StatusBlockerBannerProps) => {
  if (!pendingStatus) return null

  const statusLabel = getWorkflowStatusLabel(pendingStatus)

  return (
    <div
      className="statusBlockerBanner"
      role="status"
      aria-live="polite"
      data-testid="status-blocker-banner"
    >
      <div className="statusBlockerBannerHeader">
        <span className="statusBlockerBannerTitle">
          To mark as {statusLabel}, resolve:
        </span>
        <IconButton
          variant="tertiary"
          size="sm"
          className="statusBlockerBannerDismiss"
          label="Dismiss"
          icon={<CloseRoundedIcon fontSize="inherit" />}
          onClick={onDismiss}
        />
      </div>

      {blockers.length === 0 ? (
        <div className="statusBlockerBannerCommitting" data-testid="status-blocker-committing">
          <span className="statusBlockerBannerSpinner" aria-hidden="true" />
          <span>Marking as {statusLabel}…</span>
        </div>
      ) : (
        <div className="statusBlockerBannerChips" role="group" aria-label="Required actions">
          {blockers.map((blocker) => (
            <Pressable
              key={blocker.code}
              className="statusBlockerBannerChip"
              aria-label={blocker.message}
              onClick={() => onBlockerClick(blocker.ctaSection)}
            >
              <span>{blocker.message}</span>
            </Pressable>
          ))}
        </div>
      )}
    </div>
  )
}
